module.exports = __webpack_public_path__ + "img/lianxi.3713ca04.png";